import CustomComposerState from './CustomComposerState';

export const states = {
  CustomComposerState: CustomComposerState,
};
